import { useSearchParams } from "@remix-run/react";

import EmptyModal from "~/components/EmptyModal/EmptyModal";
import { HANDLED_ERROR, isErrorType } from "~/modules/checkout/constants";
import FailedIcon from "~/icons/FailedIcon";

import EmptyState from "../EmptyState/EmptyState";
import styles from "./ErrorModal.module.css";

// The error modal shows when the errorType search param is provided, and displays the associated error message
const ErrorModal: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const errorType = searchParams.get("errorType");

  const handleClose = () =>
    setSearchParams((x) => {
      x.delete("errorType");
      return x;
    });

  const {
    icon: Icon,
    title,
    message,
  } = errorType && isErrorType(errorType)
    ? HANDLED_ERROR[errorType]
    : {
        icon: FailedIcon,
        title: `Unrecognised error: ${errorType}`,
        message: "An unexpected error occurred. Please try again later.",
      };

  return (
    <EmptyModal visible={!!errorType} onClose={handleClose}>
      <div className={styles.content}>
        <EmptyState icon={Icon} title={title} description={message} />
      </div>
    </EmptyModal>
  );
};

export default ErrorModal;
